import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-hour-info-item',
    templateUrl: './hour-info-item.component.html',
    styleUrls: ['./hour-info-item.component.css'],
    imports: [DatePipe, TranslateModule]
})
export class HourInfoItemComponent {
  @Input() openingHour
  @Input() closingHour
}
